import { useEffect, useRef } from 'react';

import { toast } from '@/hooks/use-toast';
import { t } from '@/i18n';

import type { I18nKey } from '@/i18n';

/**
 * TRAD-3656 — 배경 오류(데이터는 보이는데 재조회 실패) 토스트. 🔴 **장애 1회당 1번.**
 *
 * 김프 30초 · 도미넌스 60초처럼 주기 재조회하는 화면에서 재조회마다 띄우면 장애 내내 토스트가 쏟아진다.
 * react-query 는 재조회가 거듭 실패하는 동안 isError 를 계속 true 로 둔다 → «false → true» 로 바뀌는 순간에만 띄운다.
 * 성공해서 false 로 돌아간 뒤 다시 실패하면 그때 또 1번(새 장애).
 *
 * 🔴 `useToast()` 훅이 아니라 독립 함수 `toast` 를 쓴다 — 레포 테스트 모킹이 파일마다 `useToast` 만 / `toast` 만 제공해서,
 *    매 렌더 부르는 `useToast()` 는 `toast` 만 모킹한 파일(ProposalFormPage 등)을 전부 죽였다. `toast` 는 실제로 띄울 때만 접근한다.
 */
export const useBackgroundErrorToast = (isBackground: boolean, titleKey: I18nKey = 'common.refresh_failed_toast') => {
  const wasBackground = useRef(false);
  useEffect(() => {
    if (isBackground && !wasBackground.current) {
      toast({ title: t(titleKey), variant: 'destructive' });
    }
    wasBackground.current = isBackground;
  }, [isBackground, titleKey]);
};
